var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    { staticClass: "notification-feed-item" },
    [
      _vm.notification.link_type
        ? _c(
            "router-link",
            {
              style: !_vm.routerLinkPayload ? "cursor: default" : null,
              attrs: { "active-class": "", to: _vm.routerLinkPayload },
            },
            [
              _c("notification-feed-item-body", {
                attrs: { notification: _vm.notification },
              }),
            ],
            1
          )
        : _vm.notification.link_url
        ? _c(
            "a",
            { attrs: { href: _vm.notification.link_url, target: "_blank" } },
            [
              _c("notification-feed-item-body", {
                attrs: { notification: _vm.notification },
              }),
            ],
            1
          )
        : _c(
            "div",
            {
              class: _vm.notification.response_id ? "disabled" : "",
              style: _vm.hasResponses ? null : "cursor: default",
              attrs: {
                "data-toggle": "modal",
                "data-target": `#modal-notification-response-${_vm.notification.notification.id}`,
              },
            },
            [
              _c("notification-feed-item-body", {
                attrs: { notification: _vm.notification },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _vm.hasResponses && !_vm.notification.response_id
        ? _c("notification-response-modal", {
            attrs: { notification: _vm.notification },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }